<template>
    <div>
        <br>
        <div class="searchContainer">
			<el-form ref="form" label-width="90px" style="display: flex;align-items: center;">
				<el-form-item label="工单详情">
					<el-button @click="backList()" size="small" type="primary">返回</el-button>
				</el-form-item>
			</el-form>
		</div>
        <div style="display:flex;">
            <div style="width:40%;">
                <WorkorderSummary></WorkorderSummary>
            </div>
            <div style="width:30%;">
                <DeviceEvents></DeviceEvents>
            </div>
            <div style="width:30%;">
                <WorkorderEvents></WorkorderEvents>
            </div>
        </div>
        <div style="display:flex;">
            <div style="width:70%;">
                <EnergyCharts></EnergyCharts>
            </div>
            <div style="width:30%;">
                <DevicesSummary></DevicesSummary>
            </div>
        </div>
    </div>
</template>
<script>
import XLSX from 'xlsx'
import WorkorderSummary from './detail/WorkorderSummary';
import DevicesSummary from './detail/DevicesSummary';
import WorkorderEvents from './detail/WorkorderEvents'
import DeviceEvents from './detail/DeviceEvents'
import EnergyCharts from './detail/EnergyCharts'

export default {
    components:{
        WorkorderSummary,
        DevicesSummary,
        WorkorderEvents,
        DeviceEvents,
        EnergyCharts
    },
    data(){
        return{
            no: '', 
            beltId: '',  
            berthId: '',  
            areaId: '',  
            queryTime: '',  
            beginTime: '',
            endTime:'',
            pageIndex:0,
            pageSize:20,
            pageCount:0,
            total:0,
            tableData: [],
            search: '',
            acceptList: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
            getFileInputKey:0,//用于让input在选中文件后重置
        }
    },
    computed:{
        berthList(){
            return this.$store.ningboStore.getters.getBerthList;
        },
        areaList(){
            return this.$store.ningboStore.getters.getAreaList;
        },
        typeList(){
            return this.$store.ningboStore.getters.getTypeList;
        }
    },
    mounted(){
    },
    watch:{
    },
    methods:{
        getBerth(berthId){
            for(var i=0; i<this.berthList.length; i++){
                if(this.berthList[i].id == berthId){
                    return this.berthList[i].name;
                }
            }
            return berthId
        },
        getArea(areaId){
            for(var i=0; i<this.areaList.length; i++){
                if(this.areaList[i].id == areaId){
                    return this.areaList[i].name;
                }
            }
            return areaId
        },
        getType(typeId, number){
            for(var i=0; i<this.typeList.length; i++){
                if(this.typeList[i].id == typeId){
                    return this.typeList[i].name + ':' + number + 'T';
                }
            }
            return typeId + ':' + number
        },
        formatBeginTime (row, column) {
            return new Date(eval('row.' + column.property)).format('yyyy-MM-dd hh:mm:ss');
        },
        formatBert(row, column){
            for(var i=0; i<this.berthList.length; i++){
                if(this.berthList[i].id == row.berthId){
                    return this.berthList[i].name;
                }
            }
            return row.berthId
        },
        formatArea(row, column){
            for(var i=0; i<this.areaList.length; i++){
                if(this.areaList[i].id == row.areaId){
                    return this.areaList[i].name;
                }
            }
            return row.areaId
        },
        formatType(row, column){
            for(var i=0; i<this.typeList.length; i++){
                if(this.typeList[i].id == row.typeId){
                    return this.typeList[i].name + ':' + row.number + 't';
                }
            }
            return row.typeId + ':' + row.number
        },
        formatState(row, column){
            if(row.runState == 0){
                return '运行中'
            }else if(row.runState == 1){
                return '暂停'
            }else if(row.runState == 2){
                return '结束'
            }else{
                return 'N/A'
            }
        },
        backList(){
            if(this.$store.ningboStore.getters.getWorkorder.runState == 2){
                this.$router.push('/ningboNewHistoryWorkorderList')
            }else{
                this.$router.push('/ningboNewWorkorderList')
            }
        },
    }
}
</script>